// extracted by mini-css-extract-plugin
export default {"editIcon":"StepTitle--editIcon--KW6S6","iconNoBorder":"StepTitle--iconNoBorder--w4ETn","defaultState":"StepTitle--defaultState--mKmxa"};